"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var styleOverrides = {
    root: function(param) {
        var theme = param.theme;
        return _define_property({
            marginTop: 17
        }, "&.".concat(_material.stepConnectorClasses.active, ", &.").concat(_material.stepConnectorClasses.completed), _define_property({}, "& .".concat(_material.stepConnectorClasses.line), {
            backgroundColor: theme.palette.primary.main
        }));
    },
    alternativeLabel: {
        left: 'calc(-50% + 35px)',
        right: 'calc(50% + 35px)',
        border: 0,
        top: 0
    },
    lineHorizontal: function(param) {
        var theme = param.theme;
        return {
            borderTopStyle: 'none',
            height: 5,
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.grey['200']
        };
    }
};
var _default = exports.default = {
    styleOverrides: styleOverrides
}; //# sourceMappingURL=MuiStepConnector.js.map
